module.exports = __webpack_public_path__ + "static/poster.1033c936.jpg";